export class EmailSender {
  // description: Class used to contain the email Sender
  public email?: string; // The E-mail address
  public displayName?: string; // The display name
}
